import React, {Component} from "react";
import {Container} from "reactstrap";
import SectionTitle from "../../components/Shared/SectionTitle";
import {Link} from "react-router-dom";
import logodark from "../../assets/images/logo-dark.png";

export default class About extends Component {

    render() {
        return (
            <React.Fragment>
                <Container className={"mt-60"}>
                    <div className={'text-center mb-4'}>
                        <Link to="#" className="logo-footer align-center">
                            <img
                                src={logodark}
                                height="200"
                                alt=""
                                className={"rounded"}
                            />
                        </Link>
                    </div>


                    <SectionTitle
                        title="Who We Are"
                        desc="Welcome to Border Stone Metals Group, your one-stop destination for all things metal. We are a leading company dedicated to providing comprehensive solutions in the world of metals. Whether you're a manufacturer, builder, or simply interested in the world of metals, our website is the ultimate resource for you."
                    />
                </Container>
            </React.Fragment>
        );
    }
}
